import * as types from "../constants/actionTypes";

export const schedulingInitialState = {
    monthlyAvailability: null,
    providerSchedule: null,
    providerList: null,
    schedule: null,
    earliestSchedule: null,
    mammogramQuestions:null,
    mammogramAnswers:null,
    mammogramQuestionsResponse:null,
    arrivalTimeSchedule:null,
    visitTypeAndLocation: null,
    createdPatient: null,
    searchRunning: false,
    success: false,
    error: false,
    visitTypeAndLocationFailed: false,
    scheduleAppointmentSuccess: false,
    scheduleAppointmentFailed: false,
    scheduleAppointmentPending: false,
    mammogramAnswersWaiting:false,
    mammogramQuestionsResponseWaiting:false,
    mammogramAnswersError:false,
    mammogramQuestionsResponseError:false,
    mammogramQuestionsWaiting:false,
    mammogramQuestionsError:false,
    response:null,
    arrivalTimeScheduleWaiting:false,
    createPatientSuccess: false,
    createPatientFailed: false,
    getSchedulePending: false,
    createPatientIds: [],
    getScheduleError: false,
    byPassProxyAndInfo: false,
    arrivalTimeScheduleError: false,
};

export default function openSchedulingReducer(state = schedulingInitialState, action) {
    switch (action.type) {

        case types.OPEN_SCHEDULE_CLEAR_REDUX_STATE:
            return schedulingInitialState;

        case types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING:
            return { ...state, searchRunning: true, success: false, error: false, visitTypeAndLocationPending:true, visitTypeAndLocationSuccess:false, visitTypeAndLocationFailed: false };

        case types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS:

            // failed calls will sometimes return 200 with an empty model: need to return failure when that happens.
            if (!action.visits || !action.visits.visitTypes || action.visits.visitTypes.length <= 0) {
                return { ...state, visitTypeAndLocation: null, searchRunning: false, success: false, error: false, visitTypeAndLocationPending: false, visitTypeAndLocationSuccess: false, visitTypeAndLocationFailed: true };
            }
            else {
                return { ...state, visitTypeAndLocation: action.visits, searchRunning: false, success: true, error: false, visitTypeAndLocationPending: false, visitTypeAndLocationSuccess: true, visitTypeAndLocationFailed: false };
            }

        case types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED:
            return { ...state, visitTypeAndLocation: null, searchRunning: false, success: false, error: true, visitTypeAndLocationPending: false, visitTypeAndLocationSuccess: false, visitTypeAndLocationFailed: true };

        case types.OPEN_SCHEDULE_EARLIEST:
            return { ...state, earliestScheduleWaiting: true, earliestScheduleError: null };
        case types.OPEN_SCHEDULE_EARLIEST_SUCCESS:
            return { ...state, earliestSchedule: action.schedule, /*searchRunning: false,*/ success: true, error: false, earliestScheduleWaiting: false, earliestScheduleError: null };
        case types.OPEN_SCHEDULE_EARLIEST_FAILURE:
            return { ...state, earliestScheduleWaiting: false, earliestScheduleError: action.error };
        
        case types.OPEN_SCHEDULE_ARRIVAL_TIME:
            return { ...state, arrivalTimeScheduleWaiting: true,arrivalTimeScheduleError: null };
        case types.OPEN_SCHEDULE_ARRIVAL_TIME_SUCCESS:
            return { ...state, arrivalTimeSchedule: action.schedule, searchRunning: false,success: true, error: false, arrivalTimeScheduleWaiting: false, arrivalTimeScheduleError: null };
        case types.OPEN_SCHEDULE_ARRIVAL_TIME_FAILURE:
            return { ...state, arrivalTimeScheduleWaiting: false, arrivalTimeScheduleError: action.error };
        
            case types.OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS:
            return { ...state, providerList: action.providers, searchRunning: false, success: true, error: false };

        case types.OPEN_SCHEDULE_AVAILABILITY_SUCCESS:
            return { ...state, monthlyAvailability: action.schedule, searchRunning: false, success: true, error: false };

        case types.OPEN_SCHEDULE_PROVIDER:
            return { ...state, searchRunning: true, success: false, error: false, getSchedulePending: true, scheduleDaysAvailable: null };

        case types.OPEN_SCHEDULE_PROVIDER_PENDING:
                return { ...state, searchRunning: true, success: false, error: false, getSchedulePending: true, scheduleDaysAvailable: null };

        case types.OPEN_SCHEDULE_PROVIDER_SUCCESS:

            // check for an empty model from the api, even if we get a 200 response.
            if (!action.provider) {
                return { ...state, providerSchedule: null, searchRunning: false, success: false, error: true, getSchedulePending: false, getScheduleError: false, scheduleDaysAvailable: false };
            }
            else {
                return { ...state, providerSchedule: action.provider, searchRunning: false, success: true, error: false, getSchedulePending: false, getScheduleError: false, scheduleDaysAvailable: action.scheduleDaysAvailable };
            }

        case types.OPEN_SCHEDULE_PROVIDER_FAILED:
            return { ...state, providerSchedule: null, searchRunning: false, success: false, error: true, getSchedulePending: false, getScheduleError: true };

        case types.OPEN_SCHEDULE_SCHEDULE_SUCCESS:
            if (action.schedule && action.schedule.date) {
                return { ...state, schedule: action.schedule, searchRunning: false, success: true, error: false, scheduleAppointmentPending: false, scheduleAppointmentSuccess: true, scheduleAppointmentFailed: false };
            }
            else {
                // return value is NOT the successful state...
                return { ...state, schedule: null, searchRunning: false, success: false, error: true, scheduleAppointmentPending: false, scheduleAppointmentSuccess: false, scheduleAppointmentFailed: true };
            }

        case types.OPEN_SCHEDULE_SCHEDULE_FAILED:
            return { ...state, searchRunning: false, success: false, error: true, scheduleAppointmentPending: false, scheduleAppointmentSuccess: false, scheduleAppointmentFailed: true, scheduleAppointmentError: action.error };

        case types.OPEN_SCHEDULE_SCHEDULE_PENDING:
            return { ...state, scheduleAppointmentPending: true, scheduleAppointmentSuccess: false, scheduleAppointmentFailed: false, createPatientSuccess: false, createPatientFailed: false  };

        case types.OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS:
            return { ...state, createdPatient: action.patient, searchRunning: false, success: true, error: false, createPatientSuccess: true, createPatientFailed: false, createPatientIds: action.patient.ids };

        case types.OPEN_SCHEDULE_CREATE_PATIENT_FAILED:
            return { ...state, createdPatient: null, searchRunning: false, success: false, error: true, scheduleAppointmentPending: false, createPatientSuccess: false, createPatientFailed: true };

        case types.LOGOUT:
            return schedulingInitialState;

        case types.UPDATE_BYPASS_PROXY_AND_INFO:
            return {...state, byPassProxyAndInfo: action.payload};


        case types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS:
            return { ...state, mammogramQuestionsWaiting: true,  mammogramQuestionsError: null };
        case types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_SUCCESS:
            return { ...state, mammogramQuestions: action.questions, searchRunning: false, mammogramAnswersError:false, success: true, error: false, mammogramQuestionsWaiting: false, mammogramQuestionsError: null };
        case types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_FAILURE:
            return { ...state, mammogramQuestionsWaiting: false, mammogramQuestions: {}, mammogramQuestionsError: true, mammogramAnswersError: true };
    
        case types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS:
            return { ...state, mammogramAnswersWaiting: true,  mammogramAnswersError: null };
        case types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_SUCCESS:
            return { ...state, mammogramAnswers: action.answers, searchRunning: false, success: true, error: false, mammogramAnswersError:false, mammogramAnswersWaiting: false, mammogramAnswersError: null };
        case types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_FAILURE:
            return { ...state, mammogramAnswersWaiting: false, mammogramAnswers: {}, mammogramQuestions: {}, mammogramAnswersError: true, mammogramQuestionsError: true};

        case types.OPEN_SCHEDULE_QUESTIONS_RESPONSE:
            return { ...state, mammogramQuestionsResponseWaiting: true,  mammogramQuestionsResponseError: null };
        case types.OPEN_SCHEDULE_QUESTIONS_RESPONSE_SUCCESS:
            return { ...state, mammogramQuestionsResponse: action.response, searchRunning: false, success: true, error: false, mammogramQuestionsResponseWaiting: false,  mammogramQuestionsResponseError: null };
        case types.OPEN_SCHEDULE_QUESTIONS_RESPONSE_FAILURE:
            return { ...state, mammogramQuestionsResponseWaiting: false, mammogramQuestionsResponseError: action.error };

        case types.OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE:
            return { ...state, mammogramAnswersWaiting: true, mammogramAnswersError: null, mammogramAnswersError: false, mammogramQuestionsError: null };
        case types.OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE_COMPLETED:
            return { ...state, mammogramAnswers: action.answers, searchRunning: false, success: true, error: false, mammogramAnswersWaiting: false, mammogramAnswersError: false, mammogramQuestionsError: null };
        default:
            return { ...state, searchRunning: false, success: false, error: false };
    }
}
